import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Fab } from "@mui/material";
import { useEffect, useState } from "react";
import "../../App.css";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300); // Show button after 300px scroll
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  };

  return (
    visible && (
      <Fab
        color="primary"
        size="small"
        onClick={scrollToTop}
        className="scroll-to-top-btn"
      >
        <KeyboardArrowUpIcon />
      </Fab>
    )
  );
};

export default ScrollToTopButton;
